import { render, staticRenderFns } from "./CaseCytologyQuestions.vue?vue&type=template&id=36b2366a&scoped=true&"
import script from "./CaseCytologyQuestions.vue?vue&type=script&lang=js&"
export * from "./CaseCytologyQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CaseCytologyQuestions.vue?vue&type=style&index=0&id=36b2366a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2366a",
  null
  
)

export default component.exports